@if (tokenModel$ | async; as tokenModel) {
    <div class="reward-token-eligible-tag" [ngClass]="tokenModel.cssClass">
        {{ tokenModel.badgeText }}
    </div>
}
